import '@mdi/font/css/materialdesignicons.css';
import '@geta/kolumbus-assets';
import 'vuetify/styles';
import '@geta/kolumbus-frontend/styles';
import '@/styles/main.scss';
import 'reflect-metadata';
import { createApp } from 'vue';
import { createVuetify } from 'vuetify';
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n';
import App from './App.vue';
import pinia from './store';
import router from './router';
import i18n from './i18n';
import v1 from '@geta/kolumbus-frontend/blueprints/v1';
import { createContainer } from '@/plugins/inversify';
import { useI18n } from 'vue-i18n';
import VueCookies from 'vue3-cookies';
import { useMainStore } from './features/common/stores';
import { setupApp } from '@geta/kolumbus-frontend/features/common';

const app = createApp(App)
    .use(createContainer())
    .use(VueCookies)
    .use(router)
    .use(pinia)
    .use(i18n)
    .use(
        createVuetify({
            blueprint: v1,
            locale: {
                adapter: createVueI18nAdapter({ i18n, useI18n })
            }
        })
    );

useMainStore()
    .loadConfig()
    .then(config => {
        if (!config) {
            throw new Error('Failed to load config');
        }

        // setup app
        app.use(setupApp(config));

        // mount app
        app.mount('#app');
    });
